<template></template>
<script>
export default {
	name: 'calHover',
	props: ['users','renforts','participantsCount','userType'],
	methods: {
	    hover(event) {
			let content = ''
			let props = event.extendedProps
			if(event.display == 'background' || event.classNames.includes(`other-office`)){//Encadrant occupé dans une structure
	        	content = '<p> Ce créneau est déjà pris pour cette personne dans une autre structure </p>'
			}else{
				content = '<div class="htmlSnotify" style="width: 130%;">'+
						  '<h4>'+event.title+'</h4>';
				if(props.booking && Object.keys(props.booking).length){//Booking
					content += this.bookingFormat(props)
				}else if(props.bookingMultiple && Object.keys(props.bookingMultiple).length){//BookingMultiple
					content += this.bookingMultipleFormat(event.start,props)
				}else{//Event
					content += this.encFormat(props)
				}
				content += '</div>'
			}
			this.$snotify.html(content,{timeout:10000,pauseOnHover:true,bodyMaxLength:200})
		},
		encFormat(props){
			if(props.userId != null){
	        	return '<p>Encadrant : <strong>'+this.users.find((u)=>u.id == props.userId).fullName+'</strong></p>'
	      	}else if(props.renfortId){
				return '<p>Encadrant : <strong>'+this.renforts.find((u)=>u.id == props.renfortId).fullName+'</strong></p>'
			}
			return '<p>Encadrant : Aucun</p>'
		},
		bookingFormat(props){
			let rdv = props.meeting_point || 'Pas de lieu rdv fixé'
			let paidStatus = props.booking.is_paid === true ? 'Payé' : 'Non-payé'
			let billingStatus = props.booking.has_billing != null ? 'Générée' : 'Non générée'
			let bookingcomment = props.booking.message/*remove tags*/ || 'Néant'
			bookingcomment = $("<div>"+bookingcomment+"</div>").text()
			let enc = props.calendar_resourceId ? ' ' : this.encFormat(props)
			bookingcomment = bookingcomment.length<=90?bookingcomment:bookingcomment.slice(0,90)+"...";
			let content = 	'<p>Client : <strong>' + props.booking.customer.fullName + '</strong></p>' +
							'<p>Tél : <strong>' + props.booking.customer.phone + '</strong></p>' +
							'<p>Rdv : <strong>' + rdv + '</strong></p>' +
							'<p>Statut : <strong>' + paidStatus + '</strong></p>' +
							'<p>Facture : <strong>' + billingStatus + '</strong></p>' +
							'<p>Remarques : <strong>'+ bookingcomment +'</strong></p>'+
							enc

			if(props.booking.booking_invitations.length>0){
				let payment = 'Paiement en ligne : '+props.booking.booking_invitations[0].amount+' € '
				if(props.booking.booking_invitations[0].order){
					content += '<p>€ '+payment+'<strong>reçu</strong></p>'
				}else{
					content += '<p>✉ '+payment+'<strong>en attente</strong></p>'
				}
			}
			return content
		},
		bookingMultipleFormat(start,props){
			let rdv = props.meeting_point || 'Pas de lieu rdv fixé'
			let comment = props.bookingMultiple.comment || 'Néant'
			let content = ''
			if(this.userType.role == 'ambassador'){
				content =  '<p>Rdv : '+moment(start).format('HH[h]ss')+' - '+
						   '<strong>' + rdv + '</strong></p>'+
						   '<p>Remarques : <strong>'+ comment +'</strong></p>'
				if(props.bookingMultiple.groups.length>0){
					content += '<p>Groupes :</p><ul>'
					for(let group of props.bookingMultiple.groups){
						content += '<li>'+group.customer.fullName+' : '+group.group_count+'</li>'
					}
					content += '</ul>'
				}
			}else{
				content = '<p>Participants : '+this.participantsCount(props.bookingMultiple.groups)+'/'+ props.bookingMultiple.total_places + '</p>'+
						  '<p>Rdv : <strong>' + rdv + '</strong></p>' +
						  '<p>Remarques : <strong>'+ comment +'</strong></p>'
			}
			return content
		},
	}
};
</script>
<style type="text/css">
	.snotifyToast {
	  	max-height: 400px !important;
		pointer-events: none;
	}
	.htmlSnotify p{
		margin: 5px 0px;
	}
</style>
